import axios from "axios";

const API_URL_HMLG = "https://h.autolog.nacionaltransportes.com";

const apiHmlg = axios.create({
  baseURL: API_URL_HMLG,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiHmlg;
